/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './custom-menu.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '@angular/router';
import * as i4 from '../../../../app/shared/custom-menu/custom-menu.component';
import * as i5 from '../../../../app/shared/settings.service';
import * as i6 from '../../../../app/auth/current-user';
const styles_CustomMenuComponent:any[] = [i0.styles];
export const RenderType_CustomMenuComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CustomMenuComponent,data:{}});
function View_CustomMenuComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'a',([] as any[]),
      [[8,'href',4]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(278528,
      (null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.toSnakeCase((<any>(<any>_v.parent).parent).context.$implicit.label);
    _ck(_v,1,0,currVal_1);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',(<any>(<any>_v.parent).parent).context.$implicit.action,
        '');
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = (<any>(<any>_v.parent).parent).context.$implicit.label;
    _ck(_v,2,0,currVal_2);
  });
}
function View_CustomMenuComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'a',([] as any[]),
      [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i1.ɵdid(671744,(null as any),0,i3.RouterLinkWithHref,[i3.Router,i3.ActivatedRoute,
          i2.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),(_l()(),
          i1.ɵted((null as any),['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.toSnakeCase((<any>(<any>_v.parent).parent).context.$implicit.label);
    _ck(_v,1,0,currVal_2);
    const currVal_3:any = i1.ɵinlineInterpolate(1,'',('/' + (<any>(<any>_v.parent).parent).context.$implicit.action),
        '');
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2).target;
    const currVal_1:any = i1.ɵnov(_v,2).href;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_4:any = (<any>(<any>_v.parent).parent).context.$implicit.label;
    _ck(_v,3,0,currVal_4);
  });
}
function View_CustomMenuComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'a',([] as any[]),
      [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i1.ɵdid(671744,(null as any),0,i3.RouterLinkWithHref,[i3.Router,i3.ActivatedRoute,
          i2.LocationStrategy],{routerLink:[0,'routerLink']},(null as any)),(_l()(),
          i1.ɵted((null as any),['','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.toSnakeCase((<any>(<any>_v.parent).parent).context.$implicit.label);
    _ck(_v,1,0,currVal_2);
    const currVal_3:any = i1.ɵinlineInterpolate(1,'',('/pages/' + (<any>(<any>_v.parent).parent).context.$implicit.action),
        '');
    _ck(_v,2,0,currVal_3);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,2).target;
    const currVal_1:any = i1.ɵnov(_v,2).href;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_4:any = (<any>(<any>_v.parent).parent).context.$implicit.label;
    _ck(_v,3,0,currVal_4);
  });
}
function View_CustomMenuComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CustomMenuComponent_3)),i1.ɵdid(16384,
          (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CustomMenuComponent_4)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CustomMenuComponent_5)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n    ']))],(_ck,
      _v) => {
    const currVal_0:any = ((<any>_v.parent).context.$implicit.type === 'link');
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = ((<any>_v.parent).context.$implicit.type === 'route');
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = ((<any>_v.parent).context.$implicit.type === 'page');
    _ck(_v,9,0,currVal_2);
  },(null as any));
}
function View_CustomMenuComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'nav-item route-item']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CustomMenuComponent_2)),i1.ɵdid(16384,
      (null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
      (null as any)),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.shouldShow(_v.context.$implicit);
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_CustomMenuComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_CustomMenuComponent_1)),i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,
      i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),
      i1.ɵted((null as any),['\n\n'])),i1.ɵncd((null as any),0)],(_ck,_v) => {
    var _co:i4.CustomMenuComponent = _v.component;
    const currVal_0:any = _co.menu.items;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_CustomMenuComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'custom-menu',
      ([] as any[]),[[2,'hidden',(null as any)]],(null as any),(null as any),View_CustomMenuComponent_0,
      RenderType_CustomMenuComponent)),i1.ɵdid(245760,(null as any),0,i4.CustomMenuComponent,
      [i5.SettingsService,i6.CurrentUser],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).shouldHide;
    _ck(_v,0,0,currVal_0);
  });
}
export const CustomMenuComponentNgFactory:i1.ComponentFactory<i4.CustomMenuComponent> = i1.ɵccf('custom-menu',
    i4.CustomMenuComponent,View_CustomMenuComponent_Host_0,{position:'position'},{},
    ['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/custom-menu/custom-menu.component.ngfactory.ts